import { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import useStyles from './styles';
import { YearListOption, YearListProps } from './types';

const CURRENT_YEAR = new Date().getFullYear();
const MAX_YEAR_OFFSET = 75;

const YearList = (props: YearListProps) => {
  const {
    label,
    maxYear = CURRENT_YEAR + MAX_YEAR_OFFSET,
    minYear = 1900,
    onChange,
    value,
    variant = 'standard',
  } = props;
  const classes = useStyles();

  const yearOptions = useMemo(() => {
    const years: YearListOption[] = [];

    for (let y = maxYear; y >= minYear; y--) {
      years.push({ value: Number(y), label: String(y) });
    }

    return years;
  }, [minYear, maxYear]);

  const selectedYear = useMemo(
    () => yearOptions.find(year => year.value === (value ?? CURRENT_YEAR)),
    [value, yearOptions]
  );

  return (
    <Autocomplete
      autoHighlight
      className={classes.input}
      disableClearable
      fullWidth
      getOptionLabel={option => option.label}
      id={label}
      onChange={onChange}
      options={yearOptions}
      renderInput={params => <TextField {...params} fullWidth label={label} name={label} variant={variant} />}
      value={selectedYear}
    />
  );
};

export default YearList;
